import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Calendar from '../../Part_Sample/Calendar';
import Tenant_Selection_Cell from '../../Part_Sample/Tenant_Selection_Cell';

export default class Bill_Settings extends Component {
	constructor(props) {
		super(props);

		this.tenant_info = this.props.param.tenant_info;
		let tenant_list = {};
		for (let key in this.tenant_info) {
			tenant_list[key] = {};
			tenant_list[key].is_selected = false;
		}

		let date = new Date();
		let from_date = new Date(date.getFullYear(), date.getMonth() - 1, 1);
		let to_date = new Date(date.getFullYear(), date.getMonth(), 0); //the last day of last month

		this.state = {
			tenant_list: tenant_list,
			selected_from_date: from_date,
			selected_to_date: to_date,
			is_show_from_calendar: false, //show "from" calendar
			is_show_to_calendar: false, //show "to" calendar
		}

		this.selected_tenant = [];
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Billing_Main');
	}

	handleUpdateSelectedList = (tenant_name) => {

		let tenant_list = this.state.tenant_list;
		for (let key in tenant_list) {
			if (key == tenant_name) {
				tenant_list[key].is_selected = true;
				this.selected_tenant.push(key);
			} else {
				tenant_list[key].is_selected = false;
				if (this.selected_tenant.includes(key)) {
					this.selected_tenant.splice(this.selected_tenant.indexOf(key), 1)
				}
			}
		}

		this.setState({
			tenant_list: tenant_list
		})
	}

	//Retrieve bill data
	rcvGetBillData = (bill_data) => {
		// Check if bill_data is empty JSON object
		if (bill_data != null && Object.keys(bill_data).length > 0) {
			this.bill_data = bill_data;
			this.props.receiver.loadPriceInfo();
		} else {
			window.app.hideLoading();
		}
	}

	//Retrieve price information
	rcvLoadPriceInfo = (price_info) => {
		if (price_info != null) {
			this.price_info = price_info;
			this.props.receiver.loadOwnerInfo();
		} else {
			window.app.hideLoading();
		}
	}

	//Retrieve owner information
	rcvLoadOwnerInfo = (owner_info) => {
		this.props.receiver.loadImage({ "name": "BillHeader.png" });
		this.owner_info = owner_info;
	}

	// Retrieve bill header image
	rcvLoadImage = (image_file) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Bill_Information',
			{
				from_date: this.state.selected_from_date, to_date: this.state.selected_to_date,
				tenant_info: this.tenant_info, tenant_name: this.selected_tenant, price_info: this.price_info,
				owner_info: this.owner_info, bill_data: this.bill_data, bill_header_image_properties: image_file
			});
	}

	//Show bill of the all tenant
	handleLeftButton2Action = () => {

		if (Object.keys(this.tenant_info).length == 0) {
			window.app.showToast(this.props.receiver.getString('please_add_tenant'), 3000);
			return;
		}

		// Check that start date cannot be later than end date
		if (this.state.selected_from_date > this.state.selected_to_date) {
			window.app.showToast(this.props.receiver.getString('start_date_later_than_end_date'), 3000);
			return;
		}

		// Check that end date cannot be earlier than start date
		if (this.state.selected_to_date < this.state.selected_from_date) {
			window.app.showToast(this.props.receiver.getString('end_date_earlier_than_start_date'), 3000);
			return;
		}

		// Differences between start date and end date cannot be more than 31 days
		let diffTime = Math.abs(this.state.selected_to_date - this.state.selected_from_date);
		let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		if (diffDays > 31) {
			window.app.showToast(this.props.receiver.getString('start_date_end_date_one_month'), 3000);
			return;
		}

		window.app.showLoading();
		this.selected_tenant = [];
		for (let key in this.tenant_info) {
			this.selected_tenant.push(key);
		}

		let bill_period = {
			"fy": this.state.selected_from_date.getFullYear(),
			"fm": this.state.selected_from_date.getMonth() + 1,
			"fd": this.state.selected_from_date.getDate(),
			"ty": this.state.selected_to_date.getFullYear(),
			"tm": this.state.selected_to_date.getMonth() + 1,
			"td": this.state.selected_to_date.getDate()
		}
		this.props.receiver.getBillData(bill_period);
	}

	//Show bill of 1 tenant
	handleLeftButtonAction = () => {
		if (this.selected_tenant.length == 0) {
			window.app.showToast(this.props.receiver.getString('please_add_tenant'), 3000);
			return;
		}

		// Check that start date cannot be later than end date
		if (this.state.selected_from_date > this.state.selected_to_date) {
			window.app.showToast(this.props.receiver.getString('start_date_later_than_end_date'), 3000);
			return;
		}

		// Check that end date cannot be earlier than start date
		if (this.state.selected_to_date < this.state.selected_from_date) {
			window.app.showToast(this.props.receiver.getString('end_date_earlier_than_start_date'), 3000);
			return;
		}

		// Differences between start date and end date cannot be more than 31 days
		let diffTime = Math.abs(this.state.selected_to_date - this.state.selected_from_date);
		let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		if (diffDays > 31) {
			window.app.showToast(this.props.receiver.getString('start_date_end_date_one_month'), 3000);
			return;
		}

		window.app.showLoading();
		let bill_period = {
			"fy": this.state.selected_from_date.getFullYear(),
			"fm": this.state.selected_from_date.getMonth() + 1,
			"fd": this.state.selected_from_date.getDate(),
			"ty": this.state.selected_to_date.getFullYear(),
			"tm": this.state.selected_to_date.getMonth() + 1,
			"td": this.state.selected_to_date.getDate(),
			"tenant": this.selected_tenant[0]
		}
		this.props.receiver.getBillData(bill_period);
	}

	handleChangeToCalDate = (selected_date) => {
		let now = new Date();
		// Check that selected_date + from_hour is smaller than the time now
		let check_date = new Date(selected_date);
		check_date.setHours(this.state.from_hour);

		if (check_date > now) {
			this.setState({
				selected_to_date: now,
				is_show_to_calendar: false
			}, this.handleQuery);
		} else {
			this.setState({
				selected_to_date: selected_date,
				is_show_to_calendar: false
			}, this.handleQuery);
		}
	}

	handleChangeFromCalDate = (selected_date) => {
		let now = new Date();
		// Check that selected_date + from_hour is smaller than the time now
		let check_date = new Date(selected_date);
		check_date.setHours(this.state.from_hour);

		if (check_date > now) {
			this.setState({
				selected_from_date: now,
				is_show_from_calendar: false
			}, this.handleQuery);
		} else {
			this.setState({
				selected_from_date: selected_date,
				is_show_from_calendar: false
			}, this.handleQuery);
		}
	}

	toggleToCalendar = () => {
		this.setState({ is_show_to_calendar: !this.state.is_show_to_calendar });
	}

	toggleFromCalendar = () => {
		this.setState({ is_show_from_calendar: !this.state.is_show_from_calendar });
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto',
		}

		let cal_width = this.props.width - 40;
		let cal_height = 200;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('bill_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ boxShadow: 'rgb(0 0 0 / 10%) 1px 1px 2px 2px', padding: 20, margin: 20, borderRadius: 20 }}>
						{/* From Date */}
						<div style={{ display: 'inline-block', width: '50%' }}>
							<span style={{ display: 'block' }}>{this.props.receiver.getString("from")}</span>
							<div onClick={this.toggleFromCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
								<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_from_date.toLocaleDateString()}</span>
							</div>
						</div>

						{/* To Date */}
						<div style={{ display: 'inline-block', width: '50%' }}>
							<span style={{ display: 'block' }}>{this.props.receiver.getString("to")}</span>
							<div onClick={this.toggleToCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
								<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_to_date.toLocaleDateString()}</span>
							</div>
						</div>
					</div>

					<div id="toCalendar" className='slideInDown' style={{}}>
						<Calendar
							onSelect={this.handleChangeToCalDate}
							style={{ visibility: this.state.is_show_to_calendar ? 'visible' : 'hidden' }}
							width={cal_width}
							height={cal_height}
							left={(this.props.width - 20) * 0.05}
							max_date={new Date()}
							selected_date={this.state.selected_to_date}
						/>
					</div>

					<div id="fromCalendar" className='slideInDown' style={{}}>
						<Calendar
							onSelect={this.handleChangeFromCalDate}
							style={{ visibility: this.state.is_show_from_calendar ? 'visible' : 'hidden' }}
							width={cal_width}
							height={cal_height}
							left={(this.props.width - 20) * 0.05}
							max_date={new Date()}
							selected_date={this.state.selected_from_date}
						/>
					</div>

					{/* Select tenant placeholder */}
					<div style={{ textAlign: 'left', marginTop: 20, marginLeft: 20 }}>
						<span className='subtitle'>{this.props.receiver.getString('sel_tenant')}</span>
					</div>

					{/* Select tenant */}
					<div style={{ height: window.innerWidth > window.innerHeight ? this.props.height - 120 : this.props.height - 293, overflow: 'auto' }}>
						{Object.keys(this.state.tenant_list).map((tenant_name) => {
							return (
								<Tenant_Selection_Cell
									id={tenant_name}
									height={this.props.height}
									width={this.props.width}
									handleSetToggle={this.handleUpdateSelectedList}
									is_selected={this.state.tenant_list[tenant_name].is_selected}
								/>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}